//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import axios from 'axios';
import { ApplicationInsights, SeverityLevel } from "@microsoft/applicationinsights-web";
import {
  ReactPlugin
} from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { signOut } from '../signout/signout';

class Interceptor {

  UseAppInsightsForError = (error) => {
    //***App Insight SetUp***//
    var reactPlugin = new ReactPlugin();
    const browserHistory = createBrowserHistory({ basename: '' });
    var appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: process.env.REACT_APP_INSIGHT_KEY,
        extensions: [reactPlugin],
        enableAutoRouteTracking: false,
        disableAjaxTracking: true,
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory },
        },
      },
    });
    appInsights.loadAppInsights();


    let payload = {
      "Severity": SeverityLevel.Error.toString(),
      "userName": JSON.parse(window.sessionStorage.getItem('UserAccount'))?.["name"],
      "Time": new Date(),
    }

    let url = error?.response?.config.url;
    let errorMessage = error?.response?.data?.errorMessage;
    let status = error?.response?.status;
    let xCorrelationId = error?.response?.headers["x-correlation-id"] ? error?.response?.headers["x-correlation-id"] : "no-correlation Id found";

    reactPlugin.trackException({ error: { errorMessage }, severityLevel: SeverityLevel.Error, properties: { "url": url, "status": status, "xCorrelationId": xCorrelationId, ...payload } })
    //**till here */

  }

  getInstance = () => {
    let instance = axios.create();
    instance.interceptors.request.use(function (_request) {
      let accessToken = window.sessionStorage.getItem('AccessToken');
      if (accessToken !== "") {
        _request.headers['Authorization'] = `Bearer ${accessToken}`;
      }
      _request.headers['Content-Type'] = 'application/json';
      return _request;
    }, function (error) {
      return Promise.reject(error);
    });

    instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status == 401) {
          signOut()
        }

        this.UseAppInsightsForError(error);
        return error.response;
      }
    );
    return instance;
  }
  getInstanceForLabels = () => {
    let instance = axios.create();
    instance.interceptors.request.use(function (_request) {
      _request.headers['Content-Type'] = 'application/json';
      return _request;
    }, function (error) {
      return Promise.reject(error);
    });

    instance.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      this.UseAppInsightsForError(error);
      return error.response;
    });
    return instance;
  }
}

export default Interceptor


